import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { ApplicationInsightsService } from './application-insights.service';

@Injectable()
export class ApplicationInsightsInterceptor implements HttpInterceptor {

  constructor(private applicationInsights: ApplicationInsightsService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const startTime = Date.now();

    return next.handle(req).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            const duration = Date.now() - startTime;
            
            // Track successful API calls
            this.applicationInsights.trackDependencyData(
              this.generateId(),
              req.url,
              req.method,
              req.url,
              true,
              event.status,
              duration
            );
          }
        },
        (error: HttpErrorResponse) => {
          const duration = Date.now() - startTime;
          
          // Track failed API calls
          this.applicationInsights.trackDependencyData(
            this.generateId(),
            req.url,
            req.method,
            req.url,
            false,
            error.status,
            duration
          );

          // Track the error
          this.applicationInsights.trackException(new Error(`HTTP ${error.status}: ${error.message}`));
        }
      )
    );
  }

  private generateId(): string {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  }
}